import { useEffect, useState } from 'react'
import * as Sentry from '@sentry/react'


export default function useShare() {
  const [showButtonCopy, setShowButtonCopy] = useState(false)
  const [shareData, setShareData] = useState()

  const handleShare = () => {
    try {
      if (navigator.canShare && navigator.canShare(shareData)) {
        navigator.share(shareData)
      }
    } catch (error) {
      if (error.toString().includes('AbortError')) Sentry.captureException(error)
    }
  }
  useEffect(() => {
    if (!navigator.canShare) setShowButtonCopy(true)
  }, [])

  return {
    handleShare,
    showButtonCopy,
    setShowButtonCopy,
    setShareData
  }
}
